export const FC_IRIS_BLUE = '#5D5FEF'
export const FC_LIGHTER_BLUE = '#EAF3FF'
export const FC_LIGHT_BLUE = '#D2DDEC'
export const FC_BLUE = '#515EA8'
export const FC_DARK_BLUE = '#091454'
export const FC_GREEN = '#2FC6A5'
export const FC_LIGHT_GREEN = '#A5F3E3'
